import Files, { type FilesValue } from "@/components/forms/files";
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

interface FieldsResilRibProps {
    /** Seul le champ `files` est écrit. */
    setValue: (name: 'files', value: FilesValue) => void;
    values: { files?: FilesValue | null };
}

const FieldsResilRib = (props: FieldsResilRibProps) => {
    const { setValue, values } = props;

    return (
        <div className="space-y-4">
            <Alert>
                <Info className="h-4 w-4" />
                <AlertDescription>
                    Suite à la résiliation, il est possible que nous devions rembourser un trop-perçu. Merci de nous transmettre votre RIB afin de sécuriser ce remboursement sur votre compte.
                </AlertDescription>
            </Alert>

            <Files
                label={'RIB'}
                name={`files[G]`}
                arrayName={'files'}
                value={values.files}
                setValue={setValue}
                code={'G'}
                accept={'image/jpeg,image/jpg,image/png,application/pdf'}
            />
            <p className="text-muted small mt-1">Format des fichiers autorisés : PDF, JPG, PNG</p>
        </div>
    );
};

export default FieldsResilRib;
